<template>
  <fragment>
    <tr v-for="ask in currOpts" :key="ask.id">
      <th>
        <label>{{ask.label}}</label>
        <el-tooltip :content="ask.help" placement="top" effect="light" v-if="ask.help">
          <i class="el-icon-question"></i>
        </el-tooltip>
        <br>
        <span class="hint">{{ask.desc}}</span>
      </th>
      <td v-for="op in ask.options" :key="op">
        <el-radio
          :label="op"
          :value="ask.answer"
          @input="(v) => changeValue(v,ask.id)"
          @change="showData"
        >&nbsp;</el-radio>
      </td>
    </tr>
  </fragment>
</template>

<script>
import _ from 'lodash'

export default {
    props: ['ratings', 'questions'],
    computed: {
        currOpts () {
            let vm = this
            // let sortedOpts = _.orderBy(vm.questions, ['sort'])
            return vm.questions.map(opt => {
                let ans = _.find(vm.ratings, { id: opt.id })
                if (ans) {
                    opt.answer = parseInt(ans.answer)
                }
                return opt
            })
        }
    },
    methods: {
        changeValue (data, id) {
            let rates = this.ratings
            let found = false
            for (var i in rates) {
                if (rates[i].id === id) {
                    rates[i].answer = data
                    found = true
                    break
                }
            }
            if (!found) {
                this.ratings.push({
                    id: id,
                    answer: data
                })
            }
        },
        showData () {
            this.$emit('ratingChanged', this.currOpts)
        },
        getDataFromChild () {
            let anslist = _.map(this.questions, o => {
                let { id, answer } = { ...o }
                return { id, answer }
            })
            let anses = _.filter(anslist, o => {
                return o.answer > -1
            })
            return anses.map(o => {
                return {
                    id: o.id,
                    answer: o.answer + ''
                }
            })
        }
    }
}
</script>

<style scoped>
</style>
